export function isSilentHttpStatus(error: unknown, ...silentStatuses: number[]): boolean {
  const status: number | undefined = (error as { status?: number } | null | undefined)?.status;
  return typeof status === 'number' && silentStatuses.includes(status);
}

